import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Footer from "./components/Footer";
import OTProfiles from "./pages/Projects/OT-Profiles/OTProfiles";
import AmazonProject from "./pages/Projects/Amazon/AmazonProject";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import './index.css';
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Art from "./pages/Sections/Art/Art";
import ArtPage from "./pages/Sections/Art/ArtPage";
import Profile from "./pages/Profile/Profile";
import Projects from "./pages/Projects/Projects";
import SoftwareEngineer from "./pages/BecomingMiscellaneous/SoftwareEngineer/SoftwareEngineer";
import Wave from "./pages/BecomingMiscellaneous/Wave/Wave";
import Contact from "./pages/Contact/Contact";
import Photography from "./pages/Paraphrenalia/Photography/Photography";
import YEAR_2024 from "./pages/Time/2024";
import YEAR_2023 from "./pages/Time/2023";
import YEAR_2011 from "./pages/Time/2011";
import YEAR_2010 from "./pages/Time/2010";
import YEAR_2008 from "./pages/Time/2008";
import Theater from "./pages/Paraphrenalia/Photography/Theater";
import Film from "./pages/Sections/Films/Film";

import Notes from "./pages/Sections/Notes/Notes";
import NotePage from "./pages/Sections/Notes/NotePage";
import Exhibits from "./pages/Sections/Exhibits/Exhibits";
import FrancisGallerySummerShow from "./pages/Sections/Exhibits/FrancisGallerySummerShow";
import NearFiction from "./pages/Sections/Exhibits/NearFiction";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/paintings/:id" element={<ArtPage />} />
          {/* Becoming Miscellaneous */}
          {/* <Route path="/coding" element={<SoftwareEngineer />} />
          <Route path="/projects/wave" element={<Wave/>} /> */}
          <Route path="/paintings" element={<Art />} />
          <Route path="/exhibits" element={<Exhibits />} />
          <Route path="/exhibits/francis-gallery-summer-show" element={<FrancisGallerySummerShow />} />
          <Route path="/exhibits/near-fiction" element={<NearFiction />} />
          {/* Notes disabled — in progress, needs revamping */}
          {/* <Route path="/notes" element={<Notes />} /> */}
          {/* <Route path="/notes/:id" element={<NotePage />} /> */}
          <Route path="/films" element={<Film />} />
          {/* Radiohead */}
          {/* <Route path="/radiohead/books" element={<Books/>}/>
          <Route path="/education" element={<Education/>}/> */}

          {/* Paraphrenalia */}
          {/* <Route path="/paraphrenalia/photography" element={<Photography/>}/>
          <Route path="/paraphrenalia/theater" element={<Theater/>}/> */}
          {/* Keeping Time */}

          {/* <Route path="/oasis-sil-naws-migration" element={<AmazonProject/>} /> */}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
